import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';

@Component({
    selector: 'app-page-header',
    standalone: true,
    imports: [CommonModule, MatIconModule, MatButtonModule],
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent {
    readonly #router = inject(Router);

    @Input() title: string = '';
    @Input() showBackButton: boolean = false;
    @Input() backRoute?: string | Array<any>;
    @Output() backClick = new EventEmitter<void>();

    onBackClick(): void {
        if (this.backClick.observed) {
            this.backClick.emit();
        } else if (this.backRoute) {
            if (typeof this.backRoute === 'string') {
                this.#router.navigate([this.backRoute]);
            } else {
                this.#router.navigate(this.backRoute);
            }
        } else {
            // Por defecto, ir hacia atrás en el historial
            window.history.back();
        }
    }
}
